import { useEffect, useState } from "react";
import { FlexGrid, Button, Link, useDialog, Typography, Card, useThemeProvider } from '@albo-ui/core'
import { SectionHeader } from "../../elements";
import { LeadsTrackingReportProps } from "../leads-tracking-report/types";
import { Home, Balance, Business, AdminPanelSettings, Groups, ErrorOutline, Lightbulb, AccountCircle, NavigateBefore, ArticleOutlined } from "@mui/icons-material";
import { useLeadSection } from "./hooks/useLeadSection";
import { useBlacklistCruise } from "./hooks/useBlacklistCruise";
import ImageDisplayDialog from "../../modals/view-images";
import ChangeStatusLead from "../../modals/change-status-lead";
import { useLeadContext } from "../../../contexts/LeadContext";
import { useCalculateRiskLead } from "./hooks/useCalculateRiskLead";
import { WidgetStyle } from "../../../util/Styles";
import { Box } from "@mui/material";
import { BlacklistCruiseSection, resolvePldStatus } from "./BlacklistCruiseSection";

const onboardingSectionsOne = [
    { title: "Información personal", sectionName: "PERSONAL_INFO", icon: <AccountCircle sx={{ marginRight: 1 }} />, type: "PFAE" },
    { title: "Datos de la Empresa", sectionName: "COMPANY_INFO", icon: <Home sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Estructura Accionaria", sectionName: "SHAREHOLDERS", icon: <Groups sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Administrador de la cuenta", sectionName: "ACCOUNT_ADMIN", icon: <AdminPanelSettings sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Nivel de riesgo", sectionName: "RISK_LEVEL", icon: <ErrorOutline sx={{ marginRight: 1 }} />, type: "PM" },
]

const onboardingSectionsTwo = [
    { title: "Datos de Empresa", sectionName: "COMPANY_INFO_ACCOUNT", icon: <Home sx={{ marginRight: 1 }} />, type: "PFAE" },
    { title: "Representantes Legales", sectionName: "LEGAL_REPRESENTATIVES", icon: <Balance sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Propietarios reales", sectionName: "REAL_OWNERS", icon: <Business sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Conocimiento del cliente", sectionName: "LEAD_DETAILS", icon: <Lightbulb sx={{ marginRight: 1 }} />, type: "PM" },
    { title: "Información adicional cliente de riesgo", sectionName: "ADDITIONAL_INFORMATION", icon: <ArticleOutlined sx={{ marginRight: 1 }} />, type: "PM" },
]

const blackListSection = {
    title: "Cruce en listas restringidas", sectionName: "COMPANY_INFO", icon: <Balance sx={{ marginRight: 1 }} />, type: "PM"
}

export const LeadsOnboardingSections = ({ changeAlert, changeLoader, changeWidgets, sectionData: lead, config, widgets, catalogs }: LeadsTrackingReportProps) => {
    const { columns, data, openSection, readySection, onSetClean, handleSectionChange, getSectionStatusLead, loading: loadingStaus, updateSectionStatusLead } = useLeadSection(changeAlert, changeLoader, config, lead)
    const { saveManualCheck, retryCruise, generateCruise } = useBlacklistCruise({ changeAlert, changeLoader, leadUuid: lead?.uuid, onSearch: (type) => handleSectionChange({ lead_uuid: lead.uuid, section_name: type }) })
    const dialogProps = useDialog()
    const changeStatusDialogProps = useDialog()
    const [images, setImages] = useState(null)
    const {edit}= useLeadContext();
    const {canCalculateRisk,calculateRisk, loading}= useCalculateRiskLead(changeAlert, config)
    const canEdit = lead?.status === 'revision' || lead?.status === 'info' || lead?.status === 'validating'
    const canCalculateRiskLevel = canCalculateRisk(lead)
    const { theme } = useThemeProvider();

    const pldStatus = resolvePldStatus(
        data?.["blacklist_external_validations"] || [],
        data?.["blacklist_internal_validations"] || [],
        lead?.pld_status as any
    );

    const onSearch = async (type: string) => {
        const sectionInfo = {
            lead_uuid: lead.uuid,
            section_name: type
        }
        handleSectionChange(sectionInfo)
    }

    const handleWidgetChange = async () => {
        const widget = {
            type: 'leadsTrackingReport',
            config: config
        }
        hasAction("clevelRisk") ? changeWidgets(widgets) : changeWidgets([widget])
    }

    const onCloseDialogFilter = () => {
        dialogProps.onClose()
    }
    const onDisplayImage = (data: Array<string>) => {
        setImages(data)
        dialogProps.openDialog()
    }
    const onConfirmUpdate = async () => {
        dialogProps.onClose()
    }
    const handleClickEditLead = () => {
        edit(lead.uuid)
    }
    const handleClickCalcularRiesgo = () => {
        if(canCalculateRiskLevel){
            calculateRisk(lead.uuid).catch((error) => {
                console.error("error al calcular el riesgo",error)
                changeAlert(true,"error", "Error al calcular el nivel de riesgo.")
            })
        }
    }

    const hasAction = (action) => {
        const cfg = widgets?.[0]?.config || config;
        return cfg?.actions?.indexOf(action) > -1;
    };
    const canRetryCruise = hasAction("pldRetry");
    const canManualCheck = hasAction("pldManualCheck");
    const canGenerateCruise = hasAction("startBlacklistValidation");

    const getSection = (item) => {
        let findSection = readySection.filter((i) => i.sectionName === item.sectionName);
        let checkSection = false;

        if(findSection.length > 0){
            checkSection = findSection[0]["status"] === "completed" ? true : false;
        }
        return [checkSection, findSection.length > 0 ? findSection[0]["subsections"] : []];

    }
 

    useEffect(() => {
        const initData = async () => {
            if (lead?.uuid) {
                await getSectionStatusLead(lead.uuid);
                onSearch("COMPANY_INFO");
            }
        };
        initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lead?.uuid])

    useEffect(() => {
        changeLoader(loadingStaus)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingStaus])

    useEffect(() => {
        changeLoader(loading)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading])

    return (
        <WidgetStyle property={String(false)}>
            <Card padding={3} fullWidth style={{ borderColor: theme.colors.manatee, height: "auto" }}>
            <FlexGrid container spacing={4} fullWidth direction="column">
                <FlexGrid container justify="space-between">
                    <FlexGrid item alignItems="center">
                        <Link onClick={handleWidgetChange} bold style={{ display: "flex", alignItems: "center" }} typography="smallTitle">
                            <NavigateBefore style={{ marginRight: 4, marginLeft: -8 }} /> Regresar al Dashboard
                        </Link>
                    </FlexGrid>
                    {!hasAction("clevelRisk") && <FlexGrid container spacing={2} alignItems="center" style={{width: "50%" , placeContent: "flex-end"}}>
                        <Box sx={{border: `1px solid ${theme.colors.primary}`, height: "48px"}} padding={1} alignContent={"center"} textAlign={'center'} borderRadius={1}>
                            <Link disabled={!canCalculateRiskLevel} bold typography="smallTitle" onClick={handleClickCalcularRiesgo}>Calcular nivel de riesgo</Link>
                        </Box>
                        <Button size='normal' disabled={!canEdit} onClick={handleClickEditLead}>Editar</Button>
                        <Button buttonType='secondary' size='normal' onClick={changeStatusDialogProps.openDialog}>Cambiar estatus</Button>
                    </FlexGrid>}
                </FlexGrid>

                <FlexGrid container direction="column">
                    <FlexGrid item >
                        <Typography variant="h2">
                            {lead.social_reason || "Correo de Registro"}
                        </Typography>
                    </FlexGrid>
                    <FlexGrid item >
                        <Typography variant="smallTitle" color="lightNeutral" >({lead.email})</Typography>
                    </FlexGrid>
                </FlexGrid>
            </FlexGrid>
            </Card>

            {/* Componente Destacado de Cruce en Listas Negras (PLD) */}
            <Box sx={{ mt: 3 }}>
                <BlacklistCruiseSection 
                    open={openSection === blackListSection.sectionName}
                    title={blackListSection.title}
                    icon={blackListSection.icon}
                    changeAlert={changeAlert}
                    lead={lead}
                    initialStatus={lead?.pld_status as any || "manual_review"}
                    onSearch={onSearch}
                    onSetClean={onSetClean}
                    externalValidations={data?.["blacklist_external_validations"] || []}
                    internalValidations={data?.["blacklist_internal_validations"] || []}
                    onRetryCruise={() => retryCruise(data?.["blacklist_external_validations"] || [])}
                    onGenerateCruise={generateCruise}
                    onSaveManualCheck={saveManualCheck}
                    canRetryCruise={canRetryCruise}
                    canManualCheck={canManualCheck}
                    canGenerateCruise={canGenerateCruise}
                />
            </Box>

            <FlexGrid container spacing={2} style={{ margin: '25px 0' }}>
                <FlexGrid item fullWidth >
                    {onboardingSectionsOne.filter((menu) => menu.type === lead.type).map((item) => {
                        let get = getSection(item);
                        return <SectionHeader key={item.sectionName} title={item.title} sectionName={item.sectionName} onSearch={onSearch} data={data} columns={columns} icon={item.icon} open={openSection === item.sectionName ? true : false} onSetClean={onSetClean} onDisplayImage={onDisplayImage} checked={get[0]} subSections={get[1]} updateSectionStatusLead={updateSectionStatusLead}/>
                    })}
                </FlexGrid>
                <FlexGrid item fullWidth >
                    {onboardingSectionsTwo.filter((menu) => menu.type === lead.type).map((item) => {
                        let get = getSection(item);
                        return <SectionHeader key={item.sectionName} title={item.title} sectionName={item.sectionName} onSearch={onSearch} data={data} columns={columns} icon={item.icon} open={openSection === item.sectionName ? true : false} onSetClean={onSetClean} onDisplayImage={onDisplayImage} checked={get[0]} subSections={get[1]} updateSectionStatusLead={updateSectionStatusLead}/>
                    })}
                </FlexGrid>
            </FlexGrid>
            <ImageDisplayDialog title={"Imágenes"} message={"Prueba"} onClose={onCloseDialogFilter} open={dialogProps.open} onConfirm={onConfirmUpdate} images={images} />

            <ChangeStatusLead
                style={{ width: "715px", maxWidth: "715px", zoom: 0.9, maxHeight: "600px" }}
                onConfirm={changeStatusDialogProps.onClose} 
                onClose={changeStatusDialogProps.onClose} 
                open={changeStatusDialogProps.open} 
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                lead={{
                    uuid: lead.uuid,
                    status: lead.status,
                    type: lead.type,
                    email: lead.email,
                    pld_approved: lead.pld_approved,
                    pld_status: lead.pld_status
                }}
                catalog={catalogs["economicActivities"]}
                config={config}
                pldStatus={pldStatus}
                />

        </WidgetStyle>
    )
}

